// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"EmptyProductOrder_wrapper__175gD","text":"EmptyProductOrder_text__2ziL7"};